const { default: types } = require("./types");

const INITIAL_STATE = {
  currentUser: {
    isAuthorized: false,
    logout: false,
    currentUserData: {},
  },
  globalLoader: false,
  snackBarParameters: {
    isOpen: false,
    severity: "error",
    autoHideDuration: 6000,
    message: "",
  },
  systemInfo: {
    kmEmail: null,
    systemVersion: null,
  },
  calendarEventsCount: null,
  votingsNoVoteCount: null,
  sessionTimeCounter: 0,
  globalReloadCounter: 0,
  inactivityLogout: false,
  redirectPath: null,
  viewProperties: null,
  wcagflags: { wcagcontr: "0", wcagfont: "0" }
};

const globalDataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_AUTHORIZED_FLAG:
      return {
        ...state,
        currentUser: {
          currentUserData: state.currentUser.currentUserData,
          isAuthorized: action.isAuthorized,
          logout: false,
        },
      };
    case types.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: {
          currentUserData: action.currentUserData,
          isAuthorized: state.currentUser.isAuthorized,
          logout: false,
        },
      };
    case types.UNSET_CURRENT_USER:
      return {
        ...state,
        currentUser: INITIAL_STATE.currentUser,
      };
    case types.SET_LOGOUT_USER:
      return {
        ...state,
        currentUser: {
          currentUserData: state.currentUser.currentUserData,
          isAuthorized: state.currentUser.isAuthorized,
          logout: true,
        },
      };
    case types.ENABLE_GLOBAL_LOADER:
      return {
        ...state,
        globalLoader: true,
      };
    case types.DISABLE_GLOBAL_LOADER:
      return {
        ...state,
        globalLoader: false,
      };
    case types.DISPLAY_SNACKBAR:
      return {
        ...state,
        snackBarParameters: action.snackBarParameters,
      };
    case types.HIDE_SNACKBAR:
      return {
        ...state,
        snackBarParameters: { ...state.snackBarParameters, isOpen: false },
      };
    case types.INCREMENT_SESSION_TIME:
      return {
        ...state,
        sessionTimeCounter: state.sessionTimeCounter + 1,
      };
    case types.INACTIVITY_LOGOUT:
      return {
        ...state,
        inactivityLogout: action.inactivityLogout,
      };
    case types.SET_SYSTEM_INFO:
      return {
        ...state,
        systemInfo: action.systemInfo,
      };
    case types.SET_CALENDAR_EVENTS_COUNT:
      return {
        ...state,
        calendarEventsCount: action.calendarEventsCount,
      };
    case types.SET_VOTINGS_NO_VOTE:
      return {
        ...state,
        votingsNoVoteCount: action.votingsNoVoteCount,
      };
    case types.SET_REDIRECT_PATH:
      return {
        ...state,
        redirectPath: action.redirectPath,
      };
    case types.UNSET_REDIRECT_PATH:
      return {
        ...state,
        redirectPath: INITIAL_STATE.redirectPath,
      };
    case types.SET_WCAG_CONTRAST:
      return {
        ...state,
        wcagflags: {
          wcagcontr: action.contrastValue,
          wcagfont: state.wcagflags.wcagfont,
        },
      };
    case types.SET_WCAG_FONTS:
      return {
        ...state,
        wcagflags: {
          wcagcontr: state.wcagflags.wcagcontr,
          wcagfont: action.fontsValue,
        },
      };
    case types.INCREMENT_RELOAD_COUNTER:
      return {
        ...state,
        globalReloadCounter: state.globalReloadCounter + 1,
      };
    case types.SET_VIEW_PROPS:
      return {
        ...state,
        viewProperties: action.viewProperties,
      };
    case types.RESET_VIEW_PROPS:
      return {
        ...state,
        viewProperties: INITIAL_STATE.viewProperties,
      };
    default:
      return state;
  }
};

export default globalDataReducer;
